import { TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoTooltip from "../../../../../common/components/functional/InfoTooltip/InfoTooltip";
import { StyledTableHeadingCell } from "../../../../../common/components/functional/simpleTable/styled";
import { FlexVerticalAligned } from "../../../../../common/components/styled/styled";

export const FringeBenefitsHeader = () => {
  const { t } = useTranslation("talentProfile");

  return (
    <TableRow>
      <StyledTableHeadingCell width="14%">
        {t("expenseType")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell width="10%">
        {t("startDate")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell width="10%">
        {t("endDate")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell width="15%">
        {t("common:description")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell width="11%" />
      <StyledTableHeadingCell width="15%">
        <FlexVerticalAligned>
          {t("common:additionalInformation")}
          <InfoTooltip
            title={t("talentProfile:onlyShownToExperts")}
            style={{ marginLeft: "4px" }}
          />
        </FlexVerticalAligned>
      </StyledTableHeadingCell>
      <StyledTableHeadingCell width="10%">{t("amount")}</StyledTableHeadingCell>
      <StyledTableHeadingCell width="11%">
        {t("includedInTotalSalary")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell width="4%" />
    </TableRow>
  );
};
